<template>
    <main>
        <h2 class="subtitle is-5">Act</h2>
        <section class="box mb-1">
            <section class="field" v-for="(plan, index) in plansA">
                <div class="field is-horizontal">
                    <div class="field-label">
                        <label class="label">{{ index + 1}}</label>
                    </div>
                    <div class="field-body">
                        {{ plan.title }}
                    </div>
                </div>
                <div class="field is-horizontal" v-if="plan.is_grantt === false">
                    <div class="field-label"></div>
                    <div class="field-body">
                        ภายใน 30 วันหลังจากดำเนินโครงการเสร็จ
                    </div>
                </div>
            </section>
        </section>
    </main>
</template>
<script type="text/babel">
    export default {
        props: {
            project: {type: Object, required: true},
            type: {type: String, required: true},
            planTitle: {type: String, required: true},
        },

        computed: {
            plansA() {
                return this.project.pdca.filter((plan) => plan.type === this.type);
            }
        },
        methods: {}
    }
</script>